import { useEffect, useState } from "react"
import { cameraLayout, type CameraLayout } from "./layout"

// Which way the phone is held, live. Never locks the orientation: people
// turn the phone, the layout follows.

function read(): CameraLayout {
  const type = typeof screen !== "undefined" ? screen.orientation?.type : undefined
  const angle = (window as Window & { orientation?: number }).orientation
  return cameraLayout(window.innerWidth, window.innerHeight, type, typeof angle === "number" ? angle : null)
}

export function useOrientation(): CameraLayout {
  const [layout, setLayout] = useState<CameraLayout>(read)
  useEffect(() => {
    const update = () =>
      setLayout((prev) => {
        const next = read()
        return next.landscape === prev.landscape && next.controls === prev.controls ? prev : next
      })
    const media = window.matchMedia("(orientation: landscape)")
    media.addEventListener("change", update)
    window.addEventListener("resize", update)
    screen.orientation?.addEventListener?.("change", update)
    return () => {
      media.removeEventListener("change", update)
      window.removeEventListener("resize", update)
      screen.orientation?.removeEventListener?.("change", update)
    }
  }, [])
  return layout
}
